import { BiTubeProduct } from '../BiTube/enum'
import { SemiConfigProductTypes } from '@src/routes/SemiConfigurators/products/SemiConfiguratorRedesign/enum'

export enum TubeProduct {
  Standard = 'standard',
  Rna = 'rna',
  Aqua = 'aqua',
  Wellred = 'wellred',
  Probe = 'PROBE',
  Cpeptide = 'cpeptide',
  Beacon = 'BEACON',
  EasyOligo = 'easyoligo',
  PureSimple = 'puresimple',
  LongOligo = 'longoligo',
  iscaledna = 'iscaledna',
}

export enum ProductUploadType {
  TubePCRUpload = 'PCR Oligos_Quick Entry',
  TubeRNAOligo = 'RNA Oligos ',
  EasyOligos = 'Easy Oligos',
  TubeDNAUpload = 'DNA Oligos in Tubes',
  Probes = 'Dual Labeled Probes',
  Aqua = 'AQUA Peptides',
  Wellred = 'WellRED Oligos',
  Beacons = 'Molecular Beacons',
  PureSimple = 'Pure and Simple',
  CustomPeptides = 'Custom Peptides',
  IscaleDna = 'iScale DNA Oligo',
  ProbesQuenched = 'Dual Quenched Probes',
  ProbesInternal = 'Internal Quenched Probes',
  Duplex = 'siRNA Duplex',
  FastDuplex = 'FAST siRNA Duplex',
  mirna = 'miRNA Duplex',
}

export enum StartRow {
  standard = 6,
  rna = 7,
  aqua = 21,
  wellred = 8,
  PROBE = 8,
  cpeptide = 5,
  BEACON = 8,
  easyoligo = 10,
  puresimple = 9,
  longoligo = 10,
  iscaledna = 6,
  mirna = 8,
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  MultipleLineError = 'MULTIPLE_LINE_ERROR',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
}

// TODO - Add this in KeyMS
export const TubeTitleMap = {
  [TubeProduct.Standard]: {
    id: 'CONF_TITLE_standard',
    defaultMessage: 'DNA Oligos in Tubes',
  },
  [TubeProduct.EasyOligo]: {
    id: 'CONF_TITLE_easyoligo',
    defaultMessage: 'Easy Oligos',
  },
  [TubeProduct.Rna]: {
    id: 'CONF_TITLE_rna',
    defaultMessage: 'RNA Oligos',
  },
  [TubeProduct.PureSimple]: {
    id: 'CONF_TITLE_puresimple',
    defaultMessage: 'Pure & Simple Primers',
  },
  [TubeProduct.iscaledna]: {
    id: 'CONF_TITLE_iscaledns',
    defaultMessage: 'iScale Oligos™ (mg & g quantity)',
  },
  [TubeProduct.LongOligo]: {
    id: 'CONF_TITLE_longoligo',
    defaultMessage: 'Long Oligos',
  },
  [TubeProduct.Wellred]: {
    id: 'CONF_TITLE_wellred',
    defaultMessage: 'WellRED Oligos',
  },
  [TubeProduct.Beacon]: {
    id: 'CONF_STANDARD_TUBES_BEACON',
    defaultMessage: 'Molecular Beacons',
  },
  [TubeProduct.Probe]: {
    id: 'CONF_STANDARD_TUBES_PROBE_NEW',
    defaultMessage: 'Dual-Labeled, Internal-Quenched & Dual-Quenched Probes',
  },
  [BiTubeProduct.LightCycler]: {
    id: 'CONF_TITLE_lightcycle',
    defaultMessage: 'Light Cycler® Probes',
  },
  [BiTubeProduct.FastDuplex]: {
    id: 'CONF_TITLE_fastduplex_redesign',
    defaultMessage: 'FAST siRNA Duplex Oligos',
  },
  [BiTubeProduct.Duplex]: {
    id: 'CONF_TITLE_duplex',
    defaultMessage: 'Custom siRNA in Tubes',
  },
  [BiTubeProduct.mirna]: {
    id: 'CONF_TITLE_mirna',
    defaultMessage: 'Custom miRNA in Tubes',
  },
  [SemiConfigProductTypes.PREDESIGNED_CRISPR_GRNA]: {
    id: 'CONF_CRISPR_GRNA_HEADER_CRISPRGRNA_UPDATED',
    defaultMessage: 'Predesigned CRISPR gRNA',
  },
  [SemiConfigProductTypes.SANGERCRISPR]: {
    id: 'CONF_CRISPR_SAGNER_HEADER_UPDATED',
    defaultMessage: 'Sanger CRISPR Clones',
  },
  [SemiConfigProductTypes.ORF]: {
    id: 'SEMI_CONF_PRODUCT_ORF',
    defaultMessage: 'ORF',
  },
  [SemiConfigProductTypes.PREDESIGNED_SHRNA]: {
    id: 'CONF_SHRNA_HEADER_SHRNA_UPDATED',
    defaultMessage: 'Predesigned shRNA',
  },
}

export const OligoNameMap = {
  [BiTubeProduct.FastDuplex]: {
    id: 'SENSE_STRAND_NAME',
    defaultMessage: 'Sense Strand Name',
  },
  [BiTubeProduct.mirna]: {
    id: 'STRAND_NAME',
    defaultMessage: 'Strand Name',
  },
}

export const AntiSenseNameMap = {
  [BiTubeProduct.FastDuplex]: {
    id: 'ANTI_SENSE_STRAND_NAME',
    defaultMessage: 'Antisense Strand Name',
  },
  [BiTubeProduct.mirna]: {
    id: 'STRAND_NAME',
    defaultMessage: 'Strand Name',
  },
}

export enum ModificationValues {
  None = '[None]',
  Phosphate = '[Phos]',
  Biotin = '[Btn]',
  AminoModifierC6 = '[AmC6]',
  AminoModifierC12 = '[AmC12]',
  Inosine = 'I',
  Uracil = 'U',
  SpacerC3 = '[SpcC3]',
}

// we have same enum apps/next-commerce/src/routes/Configurators/utils/enum.ts as Modification
// TODO Remove this and leverage above Enum
export enum ModificationTypes {
  ThreeMod = 'threeMod',
  FiveMod = 'fiveMod',
  InternalMod = 'internalMod',
  ReporterQuencher = 'reporterQuencher',
  DegenerateBases = 'degenerateBases',
  Base = 'base',
  Overhang = 'overhang',
  AntisenceFiveMod = 'antisenceFiveMod',
  AntisenceThreeMod = 'antisenceThreeMod',
}
